import React, { Component } from "react";
import Avatar from "@mui/material/Avatar";
import moment from "moment";
import building from "../../images/building.png";
import equipment from "../../images/equipment.png";
import Vechiles from "../../images/Vechiles.png";

class ActivityGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      description: "",
      title: "",
      totalvalue: {},
      exactadata: {},
    };
  }

  render() {
    return (
      <>
        <div className="adjust-grid-container">
          <div className="Center-the-Grid">
            <table id="myTable">
              <thead>
                <tr style={{ borderBottom: "1px solid #BCBFBE" }}>
                  <th>Activity</th>
                  <th>Resource</th>
                  <th>State</th>
                  <th>Performed By</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {this.props.auditList.map((item) => (
                  <tr>
                    <td style={{ padding: "4px" }}>
                      <div style={{ display: "flex", gap: "10px" }}>
                        {item.resourceType === "1" ? (
                          <img
                            src={building}
                            alt="building 1"
                            style={{
                              width: "2rem",
                              maxWidth: "100%",
                              height: "auto",
                            }}
                          />
                        ) : item.resourceType === "2" ? (
                          <img
                            src={equipment}
                            alt="equipment 2"
                            style={{
                              width: "2rem",
                              maxWidth: "100%",
                              height: "auto",
                            }}
                          />
                        ) : item.resourceType === "3" ? (
                          <img
                            src={Vechiles}
                            alt="Vechiles 3"
                            style={{
                              width: "2rem",
                              maxWidth: "100%",
                              height: "auto",
                            }}
                          />
                        ) : (
                          <Avatar sx={{ width: 32, height: 32 }}>N</Avatar>
                        )}
                        <div>{item.comefrom}</div>
                      </div>
                    </td>

                    <td style={{ padding: "4px" }}>{item.title}</td>

                    <td style={{ padding: "4px" }}>
                      {item.basedOn === "create" ||
                      item.basedOn === "complete" ||
                      item.basedOn === "delete"
                        ? `${
                            item.basedOn.charAt(0).toUpperCase() +
                            item.basedOn.slice(1)
                          }d`
                        : `${
                            item.basedOn.charAt(0).toUpperCase() +
                            item.basedOn.slice(1)
                          }ed`}{" "}
                      By
                    </td>

                    <td style={{ padding: "4px" }}>{item.firstName}</td>
                    <td style={{ padding: "4px" }}>
                      {moment(item.createDate).format("dddd, D MMMM YYYY")}

                    </td>
                  </tr>
                ))}
              </tbody>
              {this.props.auditList.length === 0 && (
                <>
                  {" "}
                  <div
                    style={{
                      fontSize: "larger",
                      fontWeight: "bolder",
                      fontFamily: "Karla",
                    }}
                  >
                    {"No Data Found"}
                  </div>{" "}
                </>
              )}
            </table>
          </div>
        </div>
      </>
    );
  }
}
export default ActivityGrid;
